import { Icon, Menu } from 'antd';
import { MenuProps } from 'antd/lib/menu';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { RouterConfig } from 'src/routers/urlConfig';
import I18N from 'src/services/I18NService';

interface ISideMenuLayoutProps extends MenuProps {
  menus: RouterConfig.IMenuData[];
}

class SideMenuLayout extends React.Component<ISideMenuLayoutProps, {}> {
  constructor(props: ISideMenuLayoutProps) {
    super(props);
  }

  renderMenuItem = (
    item: RouterConfig.IMenuData // item.route 菜单单独跳转的路由
  ) => (
    <Menu.Item key={item.path}>
      <Link to={item.path} replace={true}>
        {item.icon && <Icon type={item.icon} />}
        <span className="nav-text">{I18N.get(item.name)}</span>
      </Link>
    </Menu.Item>
  );

  renderSubMenu = (item: RouterConfig.IMenuData) => (
    <Menu.SubMenu
      key={item.path}
      title={
        <span>
          {item.icon && <Icon type={item.icon} />}
          <span className="nav-text">{I18N.get(item.name)}</span>
        </span>
      }
    >
      {(item.children || []).map(subItem => this.renderMenuItem(subItem))}
    </Menu.SubMenu>
  );

  render() {
    const { menus } = this.props;
    return (
      <Menu {...this.props}>
        {menus &&
          menus.map((item: RouterConfig.IMenuData) =>
            (item.children || []).length > 0 ? this.renderSubMenu(item) : this.renderMenuItem(item)
          )}
      </Menu>
    );
  }
}

export default SideMenuLayout;



// WEBPACK FOOTER //
// ./src/components/layouts/SideMenuLayout.tsx